import React from 'react';
import PropTypes from 'prop-types';
import styles from './Faqs.module.sass';
import Accordion from '../../../ui_kit/accordion/Accordion';

function Faq(props) {
  const { faq } = props;

  return (
    <>
      <strong dangerouslySetInnerHTML={{ __html: faq.question_text }} />
      <div dangerouslySetInnerHTML={{ __html: faq.answer_text }} />
    </>
  );
}

Faq.propTypes = {
  faq: PropTypes.shape({
    question_text: PropTypes.string,
    answer_text: PropTypes.string,
  }).isRequired,
};

function Faqs(props) {
  const { faqs } = props;

  const redeemFaqs = faqs.filter((faq) => faq.question_type === 'loyalty_program_redeem');
  const pointsFaqs = faqs.filter((faq) => faq.question_type === 'loyalty_program_points');
  const earnFaqs = faqs.filter((faq) => faq.question_type === 'loyalty_program_earn');

  return (
    <div className={styles.faqs}>
      { earnFaqs && (
        <Accordion
          headingClassName={styles['accordion-head']}
          heading="EARN"
          content={earnFaqs.map((faq) => (
            <Faq key={faq.id} faq={faq} />
          ))}
          background="spring-wood"
          headingBackground="spring-wood"
        />
      )}
      { pointsFaqs && (
        <Accordion
          headingClassName={styles['accordion-head']}
          heading="POINTS"
          content={pointsFaqs.map((faq) => (
            <Faq key={faq.id} faq={faq} />
          ))}
          background="spring-wood"
          headingBackground="spring-wood"
        />
      )}
      { redeemFaqs && (
        <Accordion
          headingClassName={styles['accordion-head']}
          heading="REDEEM"
          content={redeemFaqs.map((faq) => (
            <Faq key={faq.id} faq={faq} />
          ))}
          background="spring-wood"
          headingBackground="spring-wood"
        />
      )}
    </div>
  );
}

Faqs.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Faqs;
